import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
  ViewChildren,
  EventEmitter,
  AfterViewInit,
  DoCheck, Input, TemplateRef, forwardRef
} from "@angular/core";
import { ContentChild } from "@angular/core";
import { Subject } from "rxjs";
import { NG_VALUE_ACCESSOR, FormControl } from "@angular/forms";
import { ParameterService } from "../../utils/services/parameter.service";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import {Country} from '../../utils/objects/country';

@Component({
  selector: "app-country-dropdown",
  templateUrl: "./country-dropdown.component.html",
  styleUrls: ["./country-dropdown.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CountryDropdownComponent),
      multi: true
    }
  ]
})
export class CountryDropdownComponent implements OnInit, AfterViewInit, DoCheck {

  @ViewChild("dropdownButton") dropdownButton: ElementRef;
  @Input() dropdownItemTemplate: TemplateRef<any>;
  @Input() dropdownButtonTemplate: TemplateRef<any>;
  @Input() placeholder = "Select";
  @ViewChild("searchInput") searchInput;
  @ViewChild("dropdownMenu") dropdownMenu;
  @ViewChildren("dropdownItem") dropdownItems;
  @Input() singleSelect: boolean = false;
  @Input() searchable: boolean = true;
  @Input() setTheOnlyItemAsSelected: boolean = true;
  @Input() isClearable = true;
  private selectedIndex = 0;
  public visibleCount = 0;
  public searchInputControl = new FormControl();

  public dataList: Array<any>;
  public selectedDataList: Array<any> = [];

  @ContentChild("myelement") children;
  private keyEventSubject: Subject<string> = new Subject();

  @Input() selectedCountry: Country;
  @Input() selectedCountries: Country[] = [];
  @Output() onCountrySelected: EventEmitter<any> = new EventEmitter<any>();

  public searchParams: URLSearchParams = new URLSearchParams();
  public limit = 10;
  public propagateChange = (_: any) => { };

  private identifier = 'countryCode';

  setSelectedCall;

  @HostListener("window:click", ["$event"])
  clickHandler(event) {
    if (!(this.elementRef.nativeElement.contains(event.target))) {
      this.hideDropDown();
    }
  }


  constructor(private renderer: Renderer2, private parameterService: ParameterService,
    private elementRef: ElementRef) {
    this.searchParams.set("limit", this.limit.toString());
    this.searchParams.set("offset", "0");
    this.searchParams.set("sortBy", "countryName");
    this.searchParams.set("sortType", "ASC");
  }

  ngOnInit() {

    this.keyEventSubject.debounceTime(300).subscribe(event => {
      this.handleKeyDown(event);
    });

    this.parameterService.getCountries(this.searchParams).subscribe(
      response => {
        this.setMenuDataForInitialize(response.data);
      }, error => {
        this.setMenuDataForInitialize([]);
      }
    );
    if (this.singleSelect)
      this.setSelectedCountry([this.selectedCountry]);
    else
      this.setSelectedCountries(this.selectedCountries);
  }

  ngAfterViewInit() {

  }

  ngDoCheck() {
    if (this.dropdownButton && this.dropdownButton.nativeElement && this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0]) {
      this.visibleCount = Math.floor(this.dropdownButton.nativeElement.offsetWidth / this.dropdownButton.nativeElement.querySelectorAll(".pinned")[0].offsetWidth) - 2;
    }
  }

  setSelectedData(selectedDataList: Array<any>) {
    if (Array.isArray(selectedDataList)) {
      this.selectedDataList = selectedDataList;
    } else {
      this.selectedDataList = [];
    }
  }

  setMenuDataForInitialize(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
      if (this.setTheOnlyItemAsSelected && (this.selectedDataList && this.selectedDataList.length == 0) && (this.dataList && this.dataList.length == 1)) {
        this.setSelectedData([...this.dataList]);
        this.onDataSelected([...this.dataList]);
      }
    } else {
      this.dataList = [];
    }
  }

  setMenuDataForLoadMore(dataList: Array<any>): void {
    if (Array.isArray(dataList)) {
      this.dataList = dataList;
    } else {
      this.dataList = [];
    }
  }

  addMenuData(data) {
    this.dataList.push(data);
  }


  onDataPicked(data: any) {
    if (data) {
      if (this.singleSelect) {
        if (this.selectedDataList.length == 0) {
          this.selectedDataList[0] = data;
        } else {
          if (data[this.identifier] === this.selectedDataList[0][this.identifier]) {
            if (this.isClearable && this.selectedDataList.length > 0)
              this.selectedDataList.splice(0, 1);
          } else {
            this.selectedDataList[0] = data;
          }
        }
        this.onDataSelected(this.selectedDataList);
        this.hideDropDown();
      } else {
        const selectedIndex = this.selectedDataList.findIndex((element) => element[this.identifier] === data[this.identifier]);
        if (selectedIndex > -1) {
          this.selectedDataList.splice(selectedIndex, 1);
        } else {
          this.selectedDataList.push(data);
        }
        this.onDataSelected(this.selectedDataList);
      }
    }

  }


  showDropDown() {
    this.renderer.addClass(this.dropdownMenu.nativeElement, "show");
    if (this.dropdownItems.toArray()[this.selectedIndex]) {
      this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
    }
    if (this.searchable) {
      this.searchInput.nativeElement.click();
      this.searchInput.nativeElement.focus();
    }

  }

  hideDropDown() {
    this.renderer.removeClass(this.dropdownMenu.nativeElement, "show");
  }

  toggleDropdownMenu() {
    if (this.dropdownMenu.nativeElement.classList.contains("show")) {
      this.hideDropDown();
    }
    else {
      this.renderer.removeClass(this.dropdownMenu.nativeElement, "hide");
      this.showDropDown();
    }
  }

  keyDown(event) {
    this.keyEventSubject.next(event);
  }

  handleKeyDown(event) {
    switch (event.keyCode) {
      case 40:
        if (this.selectedIndex > this.dataList.length - 1) {
          this.selectedIndex = this.dataList.length - 1;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex++;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 38:
        if (this.selectedIndex < 1) {
          this.selectedIndex = 0;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        else {
          this.selectedIndex--;
          if (this.dropdownItems.toArray()[this.selectedIndex]) {
            this.dropdownItems.toArray()[this.selectedIndex].nativeElement.focus();
          }
        }
        break;
      case 27:
        this.hideDropDown();
        break;
      case 13:
        this.onDataPicked(this.dataList[this.selectedIndex]);
        break;
      default: {
        this.onSearchTextChanged(event);
        break;
      }
    }
  }

  onScroll() {
    this.onLoadMore(this.dataList.length);
  }

  onSearchTextChanged(event) {
    const searchText = event.target.value && event.target.value.length > 0 ? event.target.value : null;

    this.searchParams = new URLSearchParams();
    this.searchParams.set("limit", this.limit.toString());
    this.searchParams.set("offset", 0 + "");
    this.searchParams.set("sortBy", "countryName");
    this.searchParams.set("sortType", "ASC");
    if (searchText) {
      this.searchParams.set("filter_Sw", searchText);
    }
    this.parameterService.getCountries(this.searchParams).subscribe(
      response => {
        this.setMenuDataForLoadMore(response.data);
      }, error => {
        this.setMenuDataForLoadMore([]);
      }
    );
  }
  isItemSelected(item: any) {
    if (this.selectedDataList) {
      return this.selectedDataList.findIndex((element) => element[this.identifier] === item[this.identifier]) > -1 ? true : false;
    }
    return false;
  }

  writeValue(value: any) {
    if (this.singleSelect)
      this.setSelectedCountry([value]);
    else {
      this.setSelectedCountries(value);
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() { }


  onLoadMore(offset) {
    this.searchParams.set("offset", offset.toString());
    this.parameterService.getCountries(this.searchParams).subscribe(
      response => {
        response.data.forEach((country) => {
          this.addMenuData(country);
        });
      }, error => {
      }
    );
  }

  onDataSelected(selectedCountries: Array<Country>) {
    this.onCountrySelected.emit(selectedCountries ? selectedCountries : null);
    this.propagateChange(selectedCountries ? selectedCountries : null);

  }

  setSelectedCountry(selectedCountries: Array<Country>) {
    if (selectedCountries && selectedCountries.length > 0) {
      if (selectedCountries[0]) {
        let searchParams: URLSearchParams = new URLSearchParams();
        searchParams.set("countryCode_Eq", selectedCountries[0].countryCode);

        this.setSelectedCall = this.parameterService.getCountries(searchParams).subscribe(
          response => {
            this.setSelectedData(response.data);
          }, error => {
            this.setSelectedData([]);
          }
        );

      } else {
        if (this.setSelectedCall)
          this.setSelectedCall.unsubscribe();
        this.setSelectedData([]);
      }
    } else {
      if (this.setSelectedCall)
        this.setSelectedCall.unsubscribe();
      this.setSelectedData([]);
    }
  }

  setSelectedCountries(selectedCountries: Array<Country>) {
    if (selectedCountries && Array.isArray(selectedCountries) && selectedCountries.length > 0) {
      let searchParams: URLSearchParams = new URLSearchParams();
      let countries = selectedCountries.map(item => item.countryCode);
      searchParams.set("countryCode_In", countries.toString());
      this.parameterService.getCountries(searchParams).subscribe(
        response => {
          if (Array.isArray(response.data)) {
            this.selectedDataList = response.data;
          } else {
            this.selectedDataList = [];
          }
        }, error => {
          this.selectedDataList = [];
        }
      );
    } else {
      this.selectedDataList = [];
    }
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/shared/country-dropdown/country-dropdown.component.ts